import React from 'react';
import { Box, Button, Grid, Paper, Stack, TextField, Typography } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import AddIcon from '@mui/icons-material/Add';
import LockIcon from '@mui/icons-material/Lock';
import SendIcon from '@mui/icons-material/Send';
import VerifiedIcon from '@mui/icons-material/Verified';

import { BasicCodeCombo } from '../core/BasicCodeCombo';

type Props = {
  fiscalYear: string;
  versionType: string;
  approvalStage: string;
  governancePolicyCode: string;
  notes: string;
  versionTypes: any[];
  approvalStages: any[];
  selectedVersion: any | null;
  loading?: boolean;
  onFiscalYearChange: (value: string) => void;
  onVersionTypeChange: (value: string) => void;
  onApprovalStageChange: (value: string) => void;
  onGovernancePolicyChange: (value: string) => void;
  onNotesChange: (value: string) => void;
  onRefresh: () => void;
  onCreateRevision: () => void;
  onFreezeDG: () => void;
  onSubmitCA: () => void;
  onAdopt: () => void;
};

class BudgetVersionFilterBar extends React.Component<Props> {
  upper = (fn: (value: string) => void) => (value: string) => fn(String(value || '').toUpperCase());

  render() {
    const p = this.props;

    return (
      <Paper elevation={1} sx={{ p: 2, mb: 3 }}>
        <Stack direction={{ xs: 'column', md: 'row' }} justifyContent="space-between" alignItems={{ xs: 'stretch', md: 'center' }} spacing={2} sx={{ mb: 2 }}>
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
              Budget Version Controls
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Create, freeze, submit and adopt validated budget versions.
            </Typography>
          </Box>

          <Stack direction="row" spacing={1} flexWrap="wrap">
            <Button variant="outlined" startIcon={<RefreshIcon />} onClick={p.onRefresh} disabled={p.loading}>Refresh</Button>
            <Button variant="outlined" startIcon={<AddIcon />} onClick={p.onCreateRevision} disabled={p.loading}>Create Revision</Button>
            <Button variant="outlined" startIcon={<LockIcon />} onClick={p.onFreezeDG} disabled={p.loading || !p.selectedVersion}>Freeze DG</Button>
            <Button variant="outlined" startIcon={<SendIcon />} onClick={p.onSubmitCA} disabled={p.loading || !p.selectedVersion}>Submit CA</Button>
            <Button variant="contained" startIcon={<VerifiedIcon />} onClick={p.onAdopt} disabled={p.loading || !p.selectedVersion}>Adopt</Button>
          </Stack>
        </Stack>

        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 2 }}>
            <TextField size="small" label="Fiscal Year" value={p.fiscalYear} onChange={(e) => p.onFiscalYearChange(e.target.value)} fullWidth disabled={p.loading} />
          </Grid>
          <Grid size={{ xs: 12, md: 2 }}>
            <BasicCodeCombo label="Version Type" items={p.versionTypes} value={p.versionType} onChange={this.upper(p.onVersionTypeChange)} disabled={p.loading} />
          </Grid>
          <Grid size={{ xs: 12, md: 2 }}>
            <BasicCodeCombo label="Approval Stage" items={p.approvalStages} value={p.approvalStage} onChange={this.upper(p.onApprovalStageChange)} disabled={p.loading} />
          </Grid>
          <Grid size={{ xs: 12, md: 2.5 }}>
            <TextField size="small" label="Governance Policy" value={p.governancePolicyCode} onChange={(e) => p.onGovernancePolicyChange(e.target.value.toUpperCase())} fullWidth disabled={p.loading} />
          </Grid>
          <Grid size={{ xs: 12, md: 3.5 }}>
            <TextField size="small" label="Notes" value={p.notes} onChange={(e) => p.onNotesChange(e.target.value)} fullWidth disabled={p.loading} />
          </Grid>
        </Grid>
      </Paper>
    );
  }
}

export default BudgetVersionFilterBar;
